export const locale = {
    lang: 'pl',
    data: {
        "Voucher template data": "Dane karnetu",
        "Name": "Nazwa",
        "Price": "Cena",
        "Sale price": "Cena sprzedaży",
        "Save": "Zapisz",
        "New": "Nowy",
        "Active templates": "Aktywne szablony",
        "Voucher templates": "Szablony karnetów",
        "Add service": "Dodaj usługę",
        "Add product": "Dodak produkt",
        "Service": "Usługa",
        "Product": "Produkt",
        "Quantity": "Ilość",
        "Validity time (in months)": "Czas ważności (w miesiącach)",
        "Name for receipt": "Nazwa na paragonie",
        "Remove": "Usuń",
        "Actions": "Akcje",
        "Edit": "Edycja",
        "Services quantity": "Ilość usług",
        "Voucher template added successfully": "Szablon karnetu został dodany",
        "Length": "Długość",
        "Vat rate": "Stawka podatku VAT",
        "No possibility to sell!": "Brak możliwości sprzedaży karnetu!",
        "Name for receipt is empty": "Nazwa dla paragonu jest pusta",
        "Sale price for ecommerce": "Cena dla e-commerce",
        "Allow ecommerce sale": "Pozwól na sprzedaż e-commerce",
        "Name for ecommerce": "Nazwa dla e-commerce",
        "Description for ecommerce": "Opis dla e-commerce",
        "Sale net price": "Cena sprzedaży netto",
        "New voucher": "Nowy karnet",
        "Group": "Grupa",
        "New group": "Nowa grupa",
        "Voucher groups": "Grupy karnetów",
        "Delete": "Usuń",
        "Are you sure you want to delete selected voucher?": "Czy usunąć wybrany karnet?",
        "Voucher for open day": "Karnet przeznaczony na dni otwarte",
        "Hour should be in format hh:mm. Example 14:30": "Godzina powinna być w formacie hh:mm. Na przykład 14:30",
        "Active in Monday": "Aktywny w poniedziałek",
        "Active in Tuesday": "Aktywny w wtorek",
        "Active in Wednesday": "Aktywny w środę",
        "Active in Thursday": "Aktywny w czwartek",
        "Active in Friday": "Aktywny w piątek",
        "Active in Saturday": "Aktywny w sobotę",
        "Active in Sunday": "Aktywny w niedzielę",
        "Saving...": "Zapisywanie...",
        "Basic data": "Dane podstawowe",
        "Stationary sales": "Sprzedaż stacjonarna",
        "Online sales": "Sprzedaż online",
        "Mobile app sale": "Sprzedaż w aplikacji mobilnej",
        "Images": "Zdjęcia",
        "Allow mobile app sale": "Zezwól na sprzedaż w aplikacji mobilnej",
        "Validity from hour": "Aktywny od godziny",
        "Validity to hour": "Ważny do godziny",
        "Voucher for MultiSport": "Karnet dla MultiSport",
        "Voucher for Medicover": "Karnet dla Medicover",
        "Voucher for PZU Sport": "Karnet dla PZU Sport",
        "Voucher for ProFit": "Karnet dla ProFit",
        "Sale net price for ecommerce": "Cena sprzedaży dla ecommerce",
        "Available quantity": "Dostępna ilość",
        "Available from date": "Dostępny od dnia",
        "Available to date": "Dostępny do dnia",
        "Name for mobile app": "Nazwa dla aplikacji mobilnej",
        "Description for mobile app": "Opis dla aplikacji mobilnej",
        "Sale price for mobile app": "Cena sprzedaży dla aplikacji mobilnej",
        "Sale net price for mobile app": "Cena netto w sprzedaży dla aplikacji mobilnej",
        "Drag and drop file here": "Przeciągnij i upuść plik tutaj",
        "or": "lub",
        "Browse for file": "Wyszukaj plik",
        "Sorting": "Sortowanie",
        "Click and set the color.": "Kliknij i ustaw kolor",
        "Credits": "Kredyty",
        "Recommended": "Polecany",
        "The latest": "Najnowszy",
        "Type to filter vouchers list...": "Wyszukaj karnet...",
        "Commission": "Prowizja",
        "Sale commission": "Prowizja od sprzedaży",
        "All Vouchers": "Wszystkie karnety"
    }
};
